import { render, staticRenderFns } from "./Funeral.vue?vue&type=template&id=780ad604&scoped=true&lang=pug&"
import script from "./Funeral.vue?vue&type=script&lang=js&"
export * from "./Funeral.vue?vue&type=script&lang=js&"
import style0 from "./Funeral.vue?vue&type=style&index=0&id=780ad604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ad604",
  null
  
)

export default component.exports